import { collectionFilters } from '@/scripts/collections/collection-filters'

document.addEventListener('DOMContentLoaded', () => {
	collectionFilters()
})
